var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.$route.name === 'ClaimCombinationResultPrint'
      ? { background: '#fff' }
      : { background: '#F4F4F4' })},[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }